import type { StrevdaContainer, StrevdaRuntimeProps } from './props';

type SlotContextUpdate = {
  componentName: string;
  searchContext: {
    checkin: string;
    checkout?: string;
  };
  targeting: {
    startdate: string;
    enddate?: string;
  };
};

type StrevdaRuntimeInitProps = StrevdaRuntimeProps & {
  containers: StrevdaContainer[];
};

type StrevdaRuntimeModule = {
  init: (config: StrevdaRuntimeInitProps) => void;
  updateSlotContext: (update: SlotContextUpdate) => number;
};

const HOTELS_ADVERT_COMPONENT_NAME = 'flights-dayview-hotels-advert';

let cachedModule: StrevdaRuntimeModule | null = null;

const loadModule = (): Promise<StrevdaRuntimeModule> => {
  if (cachedModule) return Promise.resolve(cachedModule);

  return import(
    /* webpackChunkName: "StrevdaRuntime" */ '@skyscanner-internal/strevda-runtime'
  ).then((strevdaRuntime: StrevdaRuntimeModule) => {
    cachedModule = strevdaRuntime;
    return strevdaRuntime;
  });
};

export function init(
  strevdaRuntimeProps: StrevdaRuntimeProps,
  containers: StrevdaContainer[],
): void {
  loadModule().then((strevdaRuntime) => {
    strevdaRuntime.init({ ...strevdaRuntimeProps, containers });
  });
}

// Patches the hotels advert slot's search context in place. This re-renders
// only that slot rather than re-running setupServices, which would trigger a
// fresh page-wide ad request for every slot on each date change.
export function updateHotelAdvertDates(
  outboundDate: string,
  inboundDate: string | null,
): void {
  loadModule().then((strevdaRuntime) => {
    strevdaRuntime.updateSlotContext({
      componentName: HOTELS_ADVERT_COMPONENT_NAME,
      searchContext: {
        checkin: outboundDate,
        ...(inboundDate ? { checkout: inboundDate } : {}),
      },
      targeting: {
        startdate: outboundDate,
        ...(inboundDate ? { enddate: inboundDate } : {}),
      },
    });
  });
}
